if (!customElements.get("pre-upsell-modal")) {
  customElements.define(
    "pre-upsell-modal",
    class PreUpsellModal extends HTMLElement {
      constructor() {
        super()
        this.overlay = document.querySelector(".pre-upsell__overlay")
        this.overlay.addEventListener("click", this.close.bind(this))

        this.closeButton = this.querySelector(".pre-upsell__close")
        this.closeButton.addEventListener("click", this.close.bind(this))
      }

      open() {
        this.classList.add("show")
        this.overlay.classList.add("show")
        insertCartStat("__cartPreupsell")
      }

      close() {
        this.classList.add("fading")
        this.overlay.classList.remove("show")
        this.addEventListener(
          "animationend",
          () => {
            this.classList.remove("show", "fading")
          },
          { once: true },
        )
      }
    },
  )
}
